export const detectExternalLink = (link: string) => {
  const regExTest = /^(https|http):\/\/.*/g.test(link);
  return regExTest;
};
